import React, { Component} from 'react';
import {connect} from 'react-redux';

class Fuel extends Component {
	constructor(props){
		super(props);
	}
	componentDidMount(){
		const { dispatch } = this.props;
	}
	render() {
		return (
			<div className = "root">
                <div className = "banner">Fuel</div>
			</div>
		);
	}
}

  
export default Fuel;